import * as React from "react";
import classNames from "classnames";
import Parser from "html-react-parser";

import "../style/components/iconAnimation.scss"; 

class IconAnimation extends React.Component {
  render() {
    const { info } = this.props;

    return (
      <div className={classNames("startedIconContent", "position-relative", "d-block", { beforeElement: info.before })}>
        {info.href ? (
          <a href={info.href} target="_self" rel="noreferrer">
            <div className="startedIcon position-relative d-inline-block">
              <img className="position-absolute" src={info.icon.src} alt={info.icon.alt} />
            </div>
          </a>
        ) : (
          <div className="startedIcon position-relative d-inline-block">
            <img className="position-absolute" src={info.icon.src} alt={info.icon.alt} />
          </div>
        )}

        <div className="p-20 pl-lg-44 pr-lg-4 pl-md-3 pr-md-3 pl-0 pr-0"> 
          <p className="font16 fontWeightBold colorDark">{info.title}</p>
          <p className="font14 colorDark">{Parser(info.text)}</p>
        </div>
      </div>
    );
  }
}

export default IconAnimation;
